import {
  EditorActions,
  EditorState,
  HISTORY_ACTION_MODE,
  NodeTree,
  useEditorReturnType,
} from '@candulabs/craft';

import { InsertNodeTreesAtIndex } from 'craft/hooks';
import { createColumnOperations } from 'craft/resolvers/Columns/ColumnOperations';

export const columnsInsertNodeTreesAtIndex: InsertNodeTreesAtIndex = (
  nodeTrees: NodeTree[],
  parentNodeId: string,
  insertAtIndex: number,
  editor: useEditorReturnType,
  insert: (nodeTrees: NodeTree[], parentNodeId: string, insertAtIndex: number) => void,
) => {
  const { query } = editor;
  // first of all, check if there is any space in the column.
  const columnOperations = createColumnOperations(parentNodeId, editor);
  const columnWidth = columnOperations.getColumnWidths();
  // 12 columns, no space.
  if (columnWidth.length === 12) {
    return;
  }
  // next, check that there are no columns anywhere in the tree we're pasting
  const columnNodeTrees = nodeTrees.filter(
    ({ rootNodeId, nodes }: NodeTree) => nodes[rootNodeId].data.name === 'Column',
  );
  if (
    columnNodeTrees.length > 0 &&
    // if you have some column and some other mixed node, just bail
    (columnNodeTrees.length !== nodeTrees.length ||
      // if you have some column nodes but we can't fit them, also bail
      columnWidth.length + columnNodeTrees.length > 12)
  ) {
    return;
  }
  // we should be inserting columns
  if (columnNodeTrees.length > 0) {
    editor.actions.produceState((_: EditorState, actionsWithoutHistory: EditorActions) => {
      actionsWithoutHistory.resetEvents();
      const newTreeIds = nodeTrees.map((tree, i) => {
        const newTree: NodeTree = tree;
        actionsWithoutHistory.addNodeTree(newTree, parentNodeId, insertAtIndex + i);
        return newTree.rootNodeId;
      });

      actionsWithoutHistory.selectNode(newTreeIds);
    });
    columnOperations.spaceEvenly(HISTORY_ACTION_MODE.MERGE);
    return;
  }
  // let's add our column:
  columnOperations.newColumn(insertAtIndex);
  // let's get the new column
  const newColumnId = query.node(parentNodeId).node.data.nodes[insertAtIndex];
  // we can now insert the node trees into the newly created column
  insert(nodeTrees, newColumnId, 0);
};
